import intellegenceService from "../shared/services/intellegenceService";
import getDates from "../shared/services/date.service";
import getMessagesData from "../shared/services/messagesData.service";
import { setLogout } from "./authActions";

const REQUEST_MESSAGES = "REQUEST_MESSAGES";
const RESPONSE_MESSAGES = "RESPONSE_MESSAGES";
const REQUEST_MESSAGES_FAILURE = "REQUEST_MESSAGES_FAILURE";
const SET_MESSAGES_TABLE_DATA = "SET_MESSAGES_TABLE_DATA";
const SET_MESSAGES_PAGE = "SET_MESSAGES_PAGE";
const SET_CURRENT_MESSAGE_INDEX = "SET_CURRENT_MESSAGE_INDEX";
const SET_MESSAGES_TABLE_PAGE_DATA = "SET_MESSAGES_TABLE_PAGE_DATA";
const CLEAR_MESSAGES = "CLEAR_MESSAGES";
const SET_MESSAGES_TABLE_SCROLL = "SET_MESSAGES_TABLE_SCROLL";

const requestMessagesAction = () => {
  return {
    type: REQUEST_MESSAGES,
  };
};

const responseMessagesAction = (data) => {
  return {
    type: RESPONSE_MESSAGES,
    payload: data,
  };
};

const requestMessagesFailureAction = (errors) => {
  return {
    type: REQUEST_MESSAGES_FAILURE,
    errors,
  };
};

const setMessagesTableDataAction = (data) => {
  return {
    type: SET_MESSAGES_TABLE_DATA,
    data,
  };
};

const setMessagesTableData = (data) => {
  return (dispatch) => {
    dispatch(setMessagesTableDataAction(data));
  };
};

const getMessages = (options) => {
  return (dispatch) => {
    dispatch(requestMessagesAction());

    intellegenceService
      .getDataPositions(options.carId, {
        startDate: getDates.fixISOStringDateToPost(options.startDate),
        endDate: getDates.fixISOStringDateToPost(options.endDate),
        timeZone: (new Date().getTimezoneOffset() / 60) * -1,
      })
      .then((result) => {
        dispatch(responseMessagesAction(getMessagesData(result.data)));
      })
      .catch((error) => {
        dispatch(requestMessagesFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const setMessagesPageAction = (data) => {
  return {
    type: SET_MESSAGES_PAGE,
    data,
  };
};

const setMessagesPage = (data) => {
  return (dispatch) => {
    dispatch(setMessagesPageAction(data));
  };
};

const setCurrentMessageIndexAction = (data) => {
  return {
    type: SET_CURRENT_MESSAGE_INDEX,
    data,
  };
};

const setCurrentMessageIndex = (data) => {
  return (dispatch) => {
    dispatch(setCurrentMessageIndexAction(data));
  };
};
const setMessagesTablePageDataAction = (data) => {
  return {
    type: SET_MESSAGES_TABLE_PAGE_DATA,
    data,
  };
};

const setMessagesTablePageData = (data) => {
  return (dispatch) => {
    dispatch(setMessagesTablePageDataAction(data));
  };
};

const clearMessagesAction = () => {
  return {
    type: CLEAR_MESSAGES,
  };
};

const setMessagesTableScrollAction = (data) => {
  return {
    type: SET_MESSAGES_TABLE_SCROLL,
    data,
  };
};

const setMessagesTableScroll = (data) => {
  return (dispatch) => {
    dispatch(setMessagesTableScrollAction(data));
  };
};

export {
  REQUEST_MESSAGES,
  RESPONSE_MESSAGES,
  REQUEST_MESSAGES_FAILURE,
  SET_MESSAGES_TABLE_DATA,
  SET_MESSAGES_PAGE,
  SET_CURRENT_MESSAGE_INDEX,
  SET_MESSAGES_TABLE_PAGE_DATA,
  CLEAR_MESSAGES,
  SET_MESSAGES_TABLE_SCROLL,
  requestMessagesAction,
  responseMessagesAction,
  requestMessagesFailureAction,
  getMessages,
  setMessagesTableDataAction,
  setMessagesTableData,
  setMessagesPageAction,
  setMessagesPage,
  setCurrentMessageIndexAction,
  setCurrentMessageIndex,
  setMessagesTablePageDataAction,
  setMessagesTablePageData,
  clearMessagesAction,
  setMessagesTableScrollAction,
  setMessagesTableScroll,
};
